import { Link } from "@tanstack/react-router";
import type { StepView } from "@/app/queries";
import { Toc } from "@/ui/Toc";
import { tocItems, type Section } from "./model";

/** Левая колонка S4: оглавление «на странице» и соседние шаги. */
export function StepToc({ view, active }: { view: StepView; active: Section }) {
  const prevPrefix = view.prev_track && view.prev_track !== view.track ? `${view.prev_track} · ` : "";
  const nextPrefix = view.next_track && view.next_track !== view.track ? `${view.next_track} · ` : "";
  const nextLocked = view.next?.state === "locked";
  return (
    <div className="flex flex-col gap-3.5">
      <Toc items={tocItems(view, active)} />
      <div className="border-t border-bd pt-3.5">
        <div className="mb-2 font-mono text-[10.5px] text-mut">соседние шаги</div>
        <div className="flex flex-col gap-1 text-[12.5px] leading-[1.6]">
          {view.prev ? (
            <Link to="/step/$id" params={{ id: view.prev.id }} className="text-ink2 no-underline hover:text-acc">
              ← {prevPrefix}
              {view.prev.title}
            </Link>
          ) : (
            <span className="text-mut">← первый шаг маршрута</span>
          )}
          {view.next ? (
            nextLocked ? (
              <span className="text-mut">
                → {nextPrefix}
                {view.next.title} <span className="font-mono text-[10.5px]">(закрыт)</span>
              </span>
            ) : (
              <Link to="/step/$id" params={{ id: view.next.id }} className="text-ink2 no-underline hover:text-acc">
                → {nextPrefix}
                {view.next.title}
              </Link>
            )
          ) : (
            <span className="text-mut">→ последний шаг маршрута</span>
          )}
        </div>
      </div>
    </div>
  );
}
